import flatpickr from 'flatpickr';
import { German } from 'flatpickr/dist/l10n/de.js';

export default class Flatpickr {
  // html selector for the component
  static selectorString() {
    return '.js-date-input';
  }

  constructor(rootNode) {
    this.$refs = {
      rootNode,
    };

    this.init();
  }

  init() {
    flatpickr(this.$refs.rootNode, {
      altInput: true,
      altFormat: 'j. F Y',
      minDate: new Date(),
      locale: German,
    });
  }
}
